import type { LeaderboardEntry, Period } from '@accra/shared';
import { api } from './apiClient';

export async function fetchBoard(period: Period): Promise<LeaderboardEntry[] | null> {
  const result = await api<{ top: LeaderboardEntry[] }>('GET', `/leaderboards/${period}?limit=50`, null);
  return result?.ok ? result.top : null;
}

export async function fetchChampion(): Promise<LeaderboardEntry | null> {
  const result = await api<{ champion: LeaderboardEntry | null }>('GET', '/leaderboards/champion', null);
  return result?.ok ? result.champion : null;
}
